module.exports = __webpack_public_path__ + "img/tamago-pic.388031fe.png";